import API from "../services/api";
import StorageService from '../services/general/storage';
const attribute = "messages";

const Service = {
  get: id => {
    return new Promise((resolve, reject) => {
      API.get(id ? attribute + "/" + id : attribute).then(
        result => {
          resolve(result);
          StorageService.setCollectionObject(attribute, id, result);
        },
        error => {
          StorageService.getCollectionObject(attribute, id).then((foundStorage) => {
            resolve(foundStorage);
          }, (err) => {
            reject(err);
          })
        }
      );
    });
  },

  save: item => {
    return new Promise((resolve, reject) => {
      if (item._id) {
        API.post(attribute + "/" + item._id, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },

  delete: id => {
    return new Promise((resolve, reject) => {
      API.deleteItem(attribute + "/" + id).then(
        result => {
          resolve(result);
        },
        error => {

          reject(error);
        }
      );
    });
  },
  markRead: (id,userid) => {
    return new Promise((resolve, reject) => {
    
        API.post(attribute + "/" + id + "/user/" + userid + "/read", [], {}).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
     
    });
  }
};

export default Service;
